import { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";

const AdminLayout = ({ children, onLogout }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      setIsSidebarOpen(!mobile);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      <Sidebar isOpen={isSidebarOpen} onToggle={setIsSidebarOpen} />
      <div
        className={`flex-1 flex flex-col transition-all duration-300 overflow-hidden ${
          !isMobile ? (isSidebarOpen ? "ml-64" : "ml-16") : "ml-0"
        }`}
      >
        <Navbar onToggleSidebar={toggleSidebar} isMobile={isMobile} />
        <main className="flex-1 p-6 overflow-y-auto overflow-x-hidden bg-offWhiteBg scrollbar-thin">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
